import { TooltipProps, Tooltip as VdsTooltip } from "@vds/tooltips";

const Tooltip = ({ children, ...rest }: TooltipProps) => {
  return <VdsTooltip {...rest}>{children}</VdsTooltip>;
};

export default Tooltip;
